import { Link } from "react-router-dom";
import { CheckCircle2, ShieldCheck, Zap, Heart, Award } from "lucide-react";
import { siteConfig } from "../config/siteConfig";

const ICONS = { 0: ShieldCheck, 1: Zap, 2: Heart, 3: Award };

export const Sobre = () => {
  const { about, contact } = siteConfig;
  return (
    <div data-testid="sobre-page">
      {/* Header */}
      <section className="bg-[#f8fafc] border-b border-slate-200">
        <div className="container-site py-16 md:py-24">
          <div className="flex items-center gap-2 text-xs text-slate-500 mb-4">
            <Link to="/" className="hover:text-blue-700">
              Home
            </Link>
            <span>/</span>
            <span className="text-[#0f2a4a] font-semibold">Sobre</span>
          </div>
          <div className="eyebrow mb-3">{about.eyebrow}</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-[#0f2a4a] tracking-tight max-w-4xl leading-[1.05]">
            {about.title}
          </h1>
        </div>
      </section>

      {/* Story */}
      <section className="py-20 md:py-28">
        <div className="container-site grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="eyebrow mb-3">Nossa história</div>
            <h2 className="text-3xl md:text-4xl font-black tracking-tight mb-6">
              Tratamos a sua casa como se fosse a nossa.
            </h2>
            <p className="text-slate-600 leading-relaxed mb-4">{about.intro}</p>
            <p className="text-slate-600 leading-relaxed">
              Da pia entupida de madrugada até obras preventivas em grandes
              condomínios, nossos técnicos são treinados para agir com rapidez,
              limpeza e respeito ao seu ambiente.
            </p>

            <div className="mt-8 space-y-3">
              {[
                "Equipe própria e treinada",
                "Equipamentos modernos e seguros",
                "Sem quebrar piso ou parede",
                "Garantia de 90 dias",
              ].map((t) => (
                <div
                  key={t}
                  className="flex items-center gap-3 text-slate-700"
                >
                  <CheckCircle2 className="w-5 h-5 text-blue-700" />
                  <span className="font-medium">{t}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="absolute -inset-4 bg-green-600/10 rounded-sm" />
            <img
              src={about.image}
              alt="Profissional Dr. Pipe trabalhando"
              className="relative w-full h-[500px] object-cover rounded-sm shadow-xl"
              data-testid="about-image"
            />
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-28 bg-[#0f2a4a] text-white">
        <div className="container-site">
          <div className="max-w-2xl mb-14">
            <div className="eyebrow text-white mb-3">Nossos valores</div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tight text-white">
              Pilares que guiam cada chamado que atendemos.
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {about.values.map((v, i) => {
              const Icon = ICONS[i] || ShieldCheck;
              return (
                <div
                  key={v.title}
                  className="bg-white/5 backdrop-blur border border-white/10 p-7 rounded-sm hover:bg-white/10 transition"
                  data-testid={`value-${i}`}
                >
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-green-600 rounded-sm mb-5">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-white">{v.title}</h3>
                  <p className="mt-2 text-slate-300 text-sm leading-relaxed">
                    {v.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Service area */}
      <section className="py-20 md:py-28">
        <div className="container-site grid md:grid-cols-2 gap-12 items-start">
          <div>
            <div className="eyebrow mb-3">Área de atendimento</div>
            <h2 className="text-3xl md:text-4xl font-black tracking-tight mb-6">
              Onde a Dr. Pipe chega rápido.
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Mantemos equipes estrategicamente distribuídas para garantir o
              menor tempo de resposta possível na sua região.
            </p>
          </div>
          <div className="bg-[#f8fafc] border border-slate-200 p-8 rounded-sm">
            <ul className="space-y-4">
              {contact.serviceAreas.map((a) => (
                <li
                  key={a}
                  className="flex items-center gap-3 pb-4 border-b border-slate-200 last:border-0 last:pb-0"
                >
                  <div className="w-2 h-2 bg-green-600 rounded-full" />
                  <span className="text-[#0f2a4a] font-semibold">{a}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sobre;
